import { Box } from "@mui/material";
import { useSelectedEntity } from "../../hooks/useSelectedEntity";
import NonGeoEntityCard from "../cards/NonGeoEntityCard";
import useEntityMapModalController from "../../hooks/useEntityMapModalController";

export default function NonGeoEntityModal() {
  const { entity, endpoint } = useSelectedEntity();
  const { showModal, toggleModal, toggleContent, visibleContent } = useEntityMapModalController();

  function handleFindRelated() {
    toggleContent();
  }

  if (!entity || !showModal || !endpoint || !visibleContent) return null;

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <NonGeoEntityCard entity={entity} entityEndpoint={endpoint} onClose={toggleModal} onFindRelated={handleFindRelated} />

      {/* Content overlay */}
      <Box
        sx={{
          position: "absolute",
          height: "100%",
          width: "100%",
          bgcolor: "grey.900",
          left: 0,
          top: 0,
          opacity: 0.75,
          pointerEvents: "auto",
          zIndex: -1
        }}
      />
    </Box>
  );
}
